const INVALID_CHECKOUT_REASONS = {
  // activate-trial (StartTrialRequest)
  HAS_PAYMENT_METHOD_NONCE: 'hasPaymentMethodNonce',
  HAS_DEFAULT_PAYMENT_METHOD: 'hasDefaultPaymentMethod',
  PURCHASE_CONTEXT: 'purchaseContext',
  CHECKOUT_CONTEXT: 'checkoutContext',
  SHIPMENT_FREQUENCY: 'shipmentFrequency',
  // activate-express-checkout-trial: custom state/address (PatientAddressValidator)
  UNSUPPORTED_ZIPCODE: 'zipcodeNoProvider',
  ERROR: 'error',
  PRE_CONSULTATION_TRANSFER_TO_LIVE_CONSULTATION_STATE:
    'preConsultationTransferToLiveConsultationState',
  TRANSFER_NO_SHIPMENT: 'transferNoShipment',
  // activate-express-checkout-trial: standard request rules (field names)
  ADDRESS1: 'address1',
  CITY: 'city',
  ZIPCODE: 'zipcode',
  STATE: 'state',
  PHONE: 'phone',
  PAYMENT_NONCE: 'paymentNonce',
  VENDOR: 'vendor',
  METHOD: 'method',
  FIRSTNAME: 'firstname',
  LASTNAME: 'lastname',
} as const;

const CHECKOUT_CONTEXT = {
  InitialTreatment: 'initial-treatment',
  NewTreatment: 'new-treatment',
  TreatmentRenewal: 'treatment-renewal',
} as const;

export { INVALID_CHECKOUT_REASONS, CHECKOUT_CONTEXT };
